import { ModuleType } from '../../../../types/modules';
import AboutMe from '../../UserWidgets/AboutMe/AboutMeBoxWide';
import Stats from '../../UserWidgets/Stats/StatsBoxWide';
import {
  WatchersBoxWide as Watchers,
  WatchingBoxWide as Watching,
} from '../../UserWidgets/WatchedDeviants';
import {
  GroupsAdminBoxWide as GroupsAdmin,
  GroupsMemberBoxWide as GroupsMember,
} from '../../UserWidgets/Groups';
import MyComments from '../../UserWidgets/MyComments/MyCommentsBoxWide';
import MyBadges from '../../UserWidgets/MyBadges/MyBadgesBoxWide';

export const ModuleTypeToStatNameMap = {
  [ModuleType.WATCHERS]: 'watchers',
  [ModuleType.WATCHING]: 'watching',
  [ModuleType.BADGES_ACTIVITY]: 'badgesReceived',
  [ModuleType.GROUPS_ADMIN]: 'groupsAdmin',
  [ModuleType.GROUPS_MEMBER]: 'groupsMember',
  [ModuleType.MY_COMMENTS]: 'commentsMade',
};

export const ModuleTypeToWidgetComponentMap = {
  [ModuleType.ABOUT]: AboutMe,
  [ModuleType.STATS]: Stats,
  [ModuleType.MY_COMMENTS]: MyComments,
  [ModuleType.WATCHING]: Watching,
  [ModuleType.WATCHERS]: Watchers,
  [ModuleType.GROUPS_ADMIN]: GroupsAdmin,
  [ModuleType.GROUPS_MEMBER]: GroupsMember,
  [ModuleType.BADGES_ACTIVITY]: MyBadges,
};
